import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import apiService from "../../../Services/apiServices";
import { useToasts } from "react-toast-notifications";
import { confirmAlert } from "react-confirm-alert";
import helper from "../../../Services/helper";
import globals from "../../../Services/globals";
import UserPermissionContext from "../../Context/UserPermissionContext";
import Modal from 'react-bootstrap/Modal';

function VatMonthlyReport(props) {
  const { addToast } = useToasts();
  const [reports, setReports] = useState();
  const [dataRowPurchase, setDataRowPurchase] = useState();
  const [dataRowSale, setDataRowSale] = useState();
  const [totalVatSale30, setTotalVatSale30] = useState();
  const [totalVatPurchase67, setTotalVatPurchase67] = useState();
  const [settings, setSettings] = useState();
  const { userPermission } = useContext(UserPermissionContext);
  const reportId = props.match.params.id
  const [modalShow, setModalShow] = React.useState(false)
  const [vatReportObj, setVatReportObj] = useState()
  const [nameOfButton, setNameOfButton] = useState("");
  const [yearInput, setYearInput] = useState(new Date().getFullYear());
  const currentYear = new Date().getFullYear();
  const [vatDeclarationTypes, setVatDeclarationTypes] = useState()

  useEffect(() => {
    getSettings();
    getDataRowSaleVat(reportId);
    getDataRowPurchaseVat(reportId);
    getVatReport(reportId);
    getVatDeclarationTypes()

    console.log(yearInput)

    // getDataSaleVat(reportId);
    // getDataPurchaseVat(reportId)
    // getPermissions();
    document.getElementById('navi')?.classList.add("nav-mobile")
    return () => {
      document.getElementById('navi')?.classList.remove("nav-mobile")
    }
  }, [yearInput])

  useEffect(() => {
    if ((totalVatSale30 >= 0 || totalVatPurchase67 >= 0) && vatReportObj) {
      calclateFinal(vatReportObj);
    }
    
  }, [totalVatSale30, totalVatPurchase67, vatReportObj])

  useEffect(() => {
    if ((totalVatSale30 > 0 || totalVatPurchase67 > 0) && vatReportObj.length === 0) {
      let vat30 = totalVatSale30;
      let vat67 = totalVatPurchase67;
      let vat68 = 0;
      let vat69 = (vat67 + vat68) - vat30 > 0 ? (vat67 + vat68) - vat30 : 0;
      let vat70 = 0;
      let vat71 = (vat69 - vat70);
      let vat72 = (vat30 - vat67 - vat68) > 0 ? (vat30 - vat67 - vat68) : 0;
  
      const calculateTotalSum = (numVat) => {
        switch (numVat) {
          case 68:
            return vat68;
          case 69:
            return vat69;
          case 70:
            return vat70;
          case 71:
            return vat71;
          case 72:
            return vat72;
          default:
            return 0;
        }
      };
  
      vatDeclarationTypes.forEach((vt) => {
        const vdObj = {
          months: reportId,
          year: yearInput,
          vatDeclarationTypeId: vt.id,
          numVat: vt.numVat,
          totalSum: calculateTotalSum(vt.numVat), // Set the totalSum dynamically based on numVat
        };
  
        apiService()
          .post("vatDeclarationReport", vdObj)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.error("Error inserting VAT declaration report:", error);
          });
      });
  
      setYearInput(yearInput)
    }
  }, [totalVatSale30, totalVatPurchase67]);
  

  const getSettings = () => {
    globals().getSettings().then((response) => {
      if (response) {
        let sett = response;
        setSettings(sett)
      }
    })
  }

  const getVatReport = async (month) => {
    var params = `monthId=${month}&year=${yearInput}`;
    await apiService().query('getVatDeclarationReport', params)
      .then((response) => {
        if (response.success) {
          setVatReportObj(response.data)
        }
      })
  }

  const getVatDeclarationTypes = async () => {
    await apiService().get('vatDeclarationTypes')
      .then((response) => {
        if (response.success) {
          setVatDeclarationTypes(response.data)
        }
      })
  }

  const calclateFinal = (vatObj) => {
    let objInc = vatObj;
    let vat30 = totalVatSale30;
    let vat67 = totalVatPurchase67;
    let vat68 = objInc?.find(f => f.numVat === 68)?.totalSum || 0;
    let vat69 = (vat67 + vat68) - vat30 > 0 ? (vat67 + vat68) - vat30 : 0;
    let vat70 = objInc?.find(f => f.numVat === 70)?.totalSum || 0;
    let vat71 = (vat69 - vat70);
    let vat72 = (vat30 - vat67 - vat68) > 0 ? (vat30 - vat67 - vat68) : 0;

    objInc.forEach(f => {
      if (f.numVat === 68) f.totalSum = vat68
      if (f.numVat === 69) f.totalSum = vat69
      if (f.numVat === 70) f.totalSum = vat70
      if (f.numVat === 71) f.totalSum = vat71
      if (f.numVat === 72) f.totalSum = vat72

      apiService().put('updateVatDeclarationReport', f)
        .then(response => {
          console.log(response)
        })
    });

    setVatReportObj(objInc);

  }

  const getDataRowPurchaseVat = async (month) => {
    var params = `purchaseOrSale=${0}`;

    await apiService().query('getSaleOrPurchase', params)
      .then((response) => {
        if (response.success) {
          let dPurchase = response.data;
          var paramsForRpt = `CompanyBranch=${0}&YEAR=${yearInput}&StartMonth=${parseInt(month)}&EndMonth=${parseInt(month)}`;
          apiService().query('RptVatPurchaseReport', paramsForRpt)
            .then((response) => {
              if (response.success) {
                let d = response.data
                let totalVat = 0;
                dPurchase.forEach(e => {
                  let findq = d[0]["K" + e.number] ?? 0
                  e.total = helper().formatNumber(parseFloat(findq));
                  e.vatTotal = helper().formatNumber(parseFloat(parseFloat(findq) * (e.vat / 100)));
                  totalVat = totalVat + parseFloat(e.vatTotal?.replace(/,/g, ''))
                });
                setTotalVatPurchase67(parseFloat(totalVat))
                setDataRowPurchase(dPurchase)
              }
            })
        }
      })
  }

  const getDataRowSaleVat = async (month) => {
    var params = `purchaseOrSale=${1}`;

    await apiService().query('getSaleOrPurchase', params)
      .then((response) => {
        if (response.success) {
          var dSale = response.data;
          let totalVat = 0;
          var paramsForRpt = `CompanyBranch=${0}&YEAR=${yearInput}&StartMonth=${parseInt(month)}&EndMonth=${parseInt(month)}`;
          apiService().query('RptVatSaleReport', paramsForRpt)
            .then((response) => {
              if (response.success) {
                let d = response.data
                dSale.forEach(e => {
                  let findq = d[0]["K" + e.number] ?? 0
                  e.total = helper().formatNumber(parseFloat(findq));
                  e.vatTotal = helper().formatNumber(parseFloat(parseFloat(findq) * (e.vat / 100)));
                  totalVat = totalVat + parseFloat(e.vatTotal?.replace(/,/g, ''))
                });
                setTotalVatSale30(parseFloat(totalVat))
                setDataRowSale(dSale)
              }
            })
        }
      })
  }

  const MyVerticallyCenteredModal = (props) => {
    const [inputValue, setInputValue] = useState(
      props.name === 'vat'
        ? vatReportObj?.find(f => f.numVat === 68)?.totalSum || 0
        : vatReportObj?.find(f => f.numVat === 70)?.totalSum || 0
    );

    const handleInputChange = (e) => {
      setInputValue(e.target.value); // Update the state on input change
    };

    const handleSave = () => {
      const updatedValue = parseFloat(inputValue);
      let vatObj = vatReportObj
      if (props.name === 'vat') {
        vatObj = vatObj.map(item =>
          item.numVat === 68 ? { ...item, totalSum: updatedValue } : item
        );

      } else {
        // Update the state for `vatReportObj` where numVat is 70
        if (updatedValue <= vatObj?.find(f => f.numVat == 69)?.totalSum && updatedValue >= 0) {
          vatObj = vatObj.map(item =>
            item.numVat === 70 ? { ...item, totalSum: updatedValue } : item
          );
        } else {
          addToast(helper().translate('NUMBER_CANT_BE_BIGGER_THAN_69'), { appearance: 'error', autoDismiss: true, })
        }
      }
      props.onHide();
      calclateFinal(vatObj);
    };

    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton={false}>
          <Modal.Title id="contained-modal-title-vcenter">
            <button
              onClick={handleSave} // Trigger save when clicked
              className="btn btn-success btn-icon-split btn-sm header-tools mr-2"
            >
              <span className="icon text-white-40">
                <i className="fas fa-save" />
              </span>
              <span className="text">{helper().translate('SAVE')}</span>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-start">
            <div>
              <label className="text-xs font-weight-bold text-primary mb-0">
                {props.name === 'vat'
                  ? helper().translate("EXCESS_VAT_CARRIED_OVER_FROM_LAST_MONTH")
                  : helper().translate("REFUND_REQUEST")}
              </label>
              <input
                className={`form-control form-control-sm`}
                name="invoiceNo"
                type="text"
                value={inputValue} // Use state value for input field
                onChange={handleInputChange} // Update the state on change
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    );
  };

  function printPage() {
    window.print();
  }

  function getMonthDateRange(month) {
    const year = new Date().getFullYear();
    if (month < 1 || month > 12) {
      return "Invalid month. Please enter a number between 1 and 12.";
    }
    const formattedMonth = String(month).padStart(2, '0');

    return `${formattedMonth}/${year}`;
  }

  const years = Array.from({ length: currentYear - 2024 + 1 }, (_, index) => 2024 + index);

  return (
    <div id="content-to-print" className="container">
      <div className="container-fluid mt-5">
        <div className="row">
          <div className="col-12 mb-4">
            <h4 className="m-0 mt-1 font-weight-bold text-center text-primary ">{helper().translate("VAT_DECLARATION_FORM")}</h4>
          </div>
          <hr style={{ width: "97%", margin: "auto", height: "2px", color: "black", backgroundColor: "black" }}></hr>
          <div >
            <nav className="  header-tools no-print"  >
              <div className=" col-lg-12 p-0" id="myHeader">
                <a href={'#/report/atk/vat'} className="btn btn-success btn-icon-split btn-sm mt-2 mb-2 mr-2">
                  <span className="icon text-white-40">
                    <i className="fas fa-arrow-left " />
                  </span>
                  <span className="text ">{helper().translate('BACK')}</span>
                </a>
                {reportId == 1 ? <button onClick={() => {
                  setModalShow(true);
                  setNameOfButton("vat"); // Update another state inline
                }} className="btn btn-primary btn-icon-split btn-sm mt-2 mb-2 mr-2">
                  <span className="icon text-white-40">
                    <i className="fas fa-plus " />
                  </span>
                  <span className="text ">{helper().translate('ADD_EXCESS_VAT')}</span>
                </button> : ""}


                <button onClick={() => {
                  setModalShow(true);
                  setNameOfButton("request"); // Update another state inline
                }} className="btn btn-primary btn-icon-split btn-sm mt-2 mb-2 mr-2">
                  <span className="icon text-white-40">
                    <i className="fas fa-plus " />
                  </span>
                  <span className="text ">{helper().translate('ADD_REFUND_REQUEST')}</span>
                </button>
                <button onClick={printPage} className="btn btn-dark  btn-icon-split btn-sm mt-2 mb-2 mr-2">
                  <span className="icon text-white-40">
                    <i className="fas fa-print " />
                  </span>
                  <span className="text ">{helper().translate('PRINT')}</span>
                </button>
                <select value={yearInput} onChange={(e) => setYearInput(parseInt(e.target.value, 10))}>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                name={nameOfButton}
              />
            </nav>
          </div>
        </div>
        <div className="row mt-2 mb-4">
          <div className="divHeight35 declaration">
            <p><strong>[1] </strong>{helper().translate("VAT_DECLARATION_FORM") + ": "}<strong>{`${getMonthDateRange(reportId)}`}</strong></p>
          </div>
          <div className="divHeight35 declaration">
            <p><strong>[2] </strong>{helper().translate("FISCAL_NUMBER") + ": "}<strong>{settings?.fiscalNumber}</strong></p>
          </div>
          <div className="divHeight35 declaration">
            <p><strong>[3] </strong>{helper().translate("COMPANY_NAME") + ": "}<strong>{settings?.companyName}</strong></p>
          </div>
          <div className="divHeight35 declaration">
            <p><strong>[3] </strong>{helper().translate("ADDRESS") + ": "}<strong>{settings?.address}</strong></p>
          </div>
          <div className="divHeight35 declaration">
            <p><strong>[4] </strong>{helper().translate("CONTACT_PERSON") + ": "}<strong>{settings?.email}</strong></p>
          </div>
          <div className="divHeight35 declaration">
            <p><strong>[4] </strong>{helper().translate("PHONE") + ": "}<strong>{settings?.phoneNo}</strong></p>
          </div>
        </div>

        <div className="row  p-0 m-0">
          <div className="col-2 offset-7 p-0 bg-danger divHeight25 border border-danger rounded-top d-flex align-items-center justify-content-center ">
            <p className="m-0 text-light ">{helper().translate("SALES")}</p>
          </div>
          <div className="col-2 offset-1 p-0 bg-dark divHeight25 border border-dark rounded-top d-flex align-items-center justify-content-center ">
            <p className="m-0 text-light ">{helper().translate("CALCULATED_VAT")}</p>
          </div>
        </div>

        {dataRowSale?.map((item) => {
          return (
            <div key={item.number}> {/* Use item.number or a unique identifier for the key */}
              <div className="row m-0 p-0 divHeight25">
                <div className="col-7 dynamicDeclaration p-0">
                  <p className="custom-paragraph p-0 m-0">
                    <strong>[{item.number}] </strong>
                    {" " + item.name}
                    <span className="dots"></span>
                    [{item.number}]
                  </p>
                </div>
                <div className="col-2 dynamicDeclaration p-0">
                  <p className="p-0 text-right">
                    <strong>{item.total}</strong>
                  </p>
                </div>
                <div className="col-2 offset-1 dynamicDeclaration p-0">
                  <p className="p-0 text-right">
                    <strong>{item.vatTotal}</strong>
                  </p>
                </div>
              </div>
            </div>
          );
        })}

        <div className="row  p-0 m-0">
          <div className="offset-9 dynamicDeclaration col-1 divHeight25 d-flex align-items-center justify-content-end">
            <p className="m-0 ">[30]</p>
          </div>
          <div className="col-2  p-0 bg-dark divHeight25 border border-dark rounded-bottom d-flex align-items-center justify-content-between ">
            <p className="m-0 ml-2 text-light ">{helper().translate("TOTAL")}:</p>
            <p className="m-0 text-light fw-bold">{helper().formatNumber(totalVatSale30)}</p>
          </div>
        </div>
        <div className="row  p-0 m-0 mt-4">
          <div className="col-2 offset-7 p-0 bg-danger divHeight25 border border-danger rounded-top d-flex align-items-center justify-content-center ">
            <p className="m-0 text-light ">{helper().translate("PURCHASES")}</p>
          </div>
          <div className="col-2 offset-1 p-0 bg-dark divHeight25 border border-dark rounded-top d-flex align-items-center justify-content-center ">
            <p className="m-0 text-light ">{helper().translate("VAT_DEDUCTIBLE")}</p>
          </div>
        </div>

        {dataRowPurchase?.map((item) => {
          return (
            <div key={item.number} className="">
              <div className="row m-0 p-0 divHeight25">
                <div className="col-7 dynamicDeclaration p-0">
                  <p className="custom-paragraph p-0 m-0">
                    <strong>[{item.number}] </strong>
                    {" " + item.name}
                    <span className="dots"></span>
                    [{item.number}]
                  </p>
                </div>
                <div className="col-2 dynamicDeclaration p-0">
                  <p className="p-0 text-right">
                    <strong>{item.total}</strong>
                  </p>
                </div>
                <div className="col-2 offset-1 dynamicDeclaration p-0">
                  <p className="p-0 text-right">
                    <strong>{item.vatTotal}</strong>
                  </p>
                </div>
              </div>
            </div>
          );
        })}

        <div className="row  p-0 m-0">
          <div className="offset-9 dynamicDeclaration col-1 divHeight25 d-flex align-items-center justify-content-end">
            <p className="m-0 ">[67]</p>
          </div>
          <div className="col-2  p-0 bg-dark divHeight25 border border-dark rounded-bottom d-flex align-items-center justify-content-between ">
            <p className="m-0 ml-2 text-light ">{helper().translate("TOTAL")}:</p>
            <p className="m-0 text-light fw-bold">{helper().formatNumber(totalVatPurchase67)}</p>
          </div>
        </div>

        <div className="row  p-0 m-0 mt-4">
          <div className="col-2 offset-7 p-0 bg-danger divHeight25 border border-danger rounded-top d-flex align-items-center justify-content-center ">
            <p className="m-0 text-light ">{helper().translate("CALCULATE")}</p>
          </div>
        </div>

        {vatReportObj?.map((item) => {
          return (
            <div key={item.numVat} className="">
              <div className="row m-0 p-0 divHeight25">
                <div className="col-7 dynamicDeclaration p-0">
                  <p className="custom-paragraph p-0 m-0">
                    <strong>[{item.numVat}] </strong>
                    {" " + helper().translate(vatDeclarationTypes?.find(vd => vd.id === item.vatDeclarationTypeId)?.name)}
                    <span className="dots"></span>
                    [{item.numVat}]
                  </p>
                </div>
                <div className="col-2 dynamicDeclaration p-0">
                  <p className="p-0 text-right">
                    <strong>{helper().formatNumber(item.totalSum)}</strong>
                  </p>
                </div>
                {/* Uncomment and use this if required */}
                {/* <div className="col-2 offset-1 dynamicDeclaration p-0">
          <p className="p-0 text-right">
            <strong>{item.vatTotal}</strong>
          </p>
        </div> */}
              </div>
            </div>
          );
        })}


        {/* <div className="row m-0 p-0 divHeight25">
            <div  className=" col-7 dynamicDeclaration  p-0 ">
              <p className="custom-paragraph  p-0 m-0">
              <strong>[{"68"}] </strong>
              { " " + helper().translate("EXCESS_VAT_CARRIED_OVER_FROM_LAST_MONTH")}
              <span className="dots"></span>
              [{"68"}]
              </p>
            </div>
            <div  className=" col-2 dynamicDeclaration  p-0 ">
              <p className=" p-0 text-right">
              <strong>{"10"}</strong>
              </p>
            </div>

      </div>
      <div className="row m-0 p-0 divHeight25">
            <div  className=" col-7 dynamicDeclaration  p-0 ">
              <p className="custom-paragraph  p-0 m-0">
              <strong>[{"69"}] </strong>
              { " " + helper().translate("REMAINING_CREDIT_BALANCE")}
              <span className="dots"></span>
              [{"69"}]
              </p>
            </div>
            <div  className=" col-2 dynamicDeclaration  p-0 ">
              <p className=" p-0 text-right">
              <strong>{"8.2"}</strong>
              </p>
            </div>

      </div>
      <div className="row m-0 p-0 divHeight25">
            <div  className=" col-7 dynamicDeclaration  p-0 ">
              <p className="custom-paragraph  p-0 m-0">
              <strong>[{"70"}] </strong>
              { " " + helper().translate("REFUND_REQUEST")}
              <span className="dots"></span>
              [{"70"}]
              </p>
            </div>
            <div  className=" col-2 dynamicDeclaration  p-0 ">
              <p className=" p-0 text-right">
              <strong>{"0"}</strong>
              </p>
            </div>

      </div>
      <div className="row m-0 p-0 divHeight25">
            <div  className=" col-7 dynamicDeclaration  p-0 ">
              <p className="custom-paragraph  p-0 m-0">
              <strong>[{"71"}] </strong>
              { " " + helper().translate("VAT_CREDIT_FOR_THE_FOLLOWING_MONTH")}
              <span className="dots"></span>
              [{"71"}]
              </p>
            </div>
            <div  className=" col-2 dynamicDeclaration  p-0 ">
              <p className=" p-0 text-right">
              <strong>{"8.2"}</strong>
              </p>
            </div>

      </div>
      <div className="row m-0 p-0 divHeight25">
            <div  className=" col-7 dynamicDeclaration  p-0 ">
              <p className="custom-paragraph  p-0 m-0">
              <strong>[{"72"}] </strong>
              { " " + helper().translate("VAT_TO_BE_PAID")}
              <span className="dots"></span>
              [{"72"}]
              </p>
            </div>
            <div  className=" col-2 dynamicDeclaration  p-0 ">
              <p className=" p-0 text-right">
              <strong>{"0"}</strong>
              </p>
            </div>

      </div> */}
      </div>
    </div>
  )
}


export default VatMonthlyReport;